import { render, staticRenderFns } from "./infoblob.vue?vue&type=template&id=ca45430c&scoped=true&"
import script from "./infoblob.vue?vue&type=script&lang=js&"
export * from "./infoblob.vue?vue&type=script&lang=js&"
import style0 from "./infoblob.vue?vue&type=style&index=0&id=ca45430c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca45430c",
  null
  
)

export default component.exports